<template>
  <div>
    <base-header type class="rsgradient pb-3 pb-1 pt-3 pt-md-5"></base-header>
    <b-card style="margin: 20px">
      <b-card-header header-tag="header" class="p-1" role="tab">Elegir Estacionamiento</b-card-header>
      <b-card-body>
        <form-wizard ref="wizard" :hide-buttons="true" title subtitle>
          <tab-content title="Producto" icon="fa fa-mobile-alt" :before-change="validateArticulo">
            <div class="row form-group">
              <div class="col-md-12">
                <div class="col-md-12">
                  <div class="row" style="background-color: white;">
                    <div
                      v-for="item in articulos"
                      @click="itemClicked(item)"
                      v-bind:key="item.Id"
                      :value="item.Id"
                      class="col-md-6 col-sm-6"
                      style="padding: 5px; cursor: pointer; margin-right: 0; margin-left: 0"
                    >
                      <div class="text-center">
                        <img :src="item.Image" style="width: 50px" :alt="item.Name" />
                      </div>
                      <div class="text-center">{{item.Name}}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </tab-content>
          <tab-content title="Datos" icon="fa fa-address-card">
            <div class="text-center" style="background-color: white;">
              <div style="padding: 5px; cursor: pointer;">
                <div class="text-center">
                  <img
                    :src="articuloSelected.image"
                    style="width: 100px"
                    :alt="articuloSelected.name"
                  />
                </div>
                <div class="text-center">{{articuloSelected.name}}</div>
              </div>
            </div>

            <EstacJuninFormType
              v-if="JuninArticleID == articuloSelected.Id"
              v-model="model"
              :model="model"
              v-on:saldoOK="onSaldoOK"
            />
            <EstacOlavarriaFormType
              v-if="OlavarriaArticleID == articuloSelected.Id"
              v-model="model"
              :model="model"
              v-on:saldoOK="onSaldoOK"
            />
            <EstacCordobaFormType
              v-if="CordobaArticleID == articuloSelected.Id"
              v-model="model"
              :model="model"
              v-on:saldoOK="onSaldoOK"
            />

            <div class="row text-right" style="margin-top:10px">
              <div class="col-md-12">
                <save-button
                  text="Recargar"
                  @click="onRealizarRecarga"
                  :disabled="btnRecargarDisabled"
                />
              </div>
            </div>
          </tab-content>

          <!-- Resultado de la  -->
          <tab-content title="Resultado" icon="fa fa-fw fa-flag">
            <div class="row">
              <div class="col-md-12">
                <base-alert :type="resultado.Tipo">
                  <span class="alert-inner--icon">
                    <i :class="resultado.Icono"></i>
                  </span>
                  <span class="alert-inner--text" v-html="resultado.Texto"></span>
                </base-alert>
              </div>
            </div>
            <!-- Nueva  -->
            <div class="row">
              <div class="col-md-12 text-center">
                <base-button
                  type="success"
                  size="lg"
                  @click="nuevaRecarga"
                  style="margin: auto; margin-top: 10px"
                >
                  <i class="fa fa-plus fa-fw"></i>Nueva
                </base-button>
              </div>
            </div>
          </tab-content>
        </form-wizard>
      </b-card-body>
    </b-card>
  </div>
</template>


<style scoped>
.wizard-footer-right button {
  display: none !important;
}

.wizard-footer-left button {
  display: none !important;
}

.pre-formatted {
  white-space: pre;
}
</style>

<script>
// ******************** Select ********************//
import Vue from "vue";
import { FormWizard, TabContent, WizardStep } from "vue-form-wizard";
import vSelect from "vue-select";
import store from "@/store";

import EstacJuninFormType from "@/components/FormsType/EstacJuninFormType";
import EstacOlavarriaFormType from "@/components/FormsType/EstacOlavarriaFormType";
import EstacCordobaFormType from "@/components/FormsType/EstacCordobaFormType";
import notificationHelpers from "@/helpers/notificationHelpers";

import "vue-select/dist/vue-select.css";
import "vue-form-wizard/dist/vue-form-wizard.min.css";

Vue.component("v-select", vSelect);

// ******************** Select ********************//

import axiosHelpers from "@/helpers/axiosHelpers";
export default {
  components: {
    FormWizard,
    TabContent,
    WizardStep,
    EstacJuninFormType,
    EstacCordobaFormType,
    EstacOlavarriaFormType,
    notificationHelpers
  },
  data() {
    return {
      model: {
        Aux1: "",
        Aux2: "",
        Aux3: "",
        Aux4: "",
        Importe: 0,
        Errors: []
      },
      articulos: [],
      articuloSelected: { Id: 0, image: "", name: "" },
      formType: 0,
      saldos: { FormatedAmount: "", FormatedAvailableAmount: "" },
      resultado: { Icono: "", Texto: "", Tipo: "" },
      estados: { Aprobado: 3, Rechazado: 4, Consulta: 5 },
      usePaymentPin: false,
      showModalPinValidation: false,
      isEdenor: false,
      ticket: { Icono: "", Texto: "", Tipo: "" },
      btnRecargarDisabled: false,
      JuninArticleID: "",
      CordobaArticleID: "",
      OlavarriaArticleID: ""
    };
  },
  methods: {
    async cargarArticulos(context) {
      axiosHelpers.axiosGet("Article/GetParkingArticles", {}, context, function(
        data
      ) {
        context.articulos = data.ResponseVM.Articles;
        // context.articulos.forEach(
        //   item =>
        //     (item.Image = "http://192.168.100.81:171/Images/Article/39.png")
        // );
      });
    },
    onRealizarRecarga() {
      this.validate();
    },
    realizarRecarga() {
      let context = this;

      let req = {
        Aux1: context.model.Aux1,
        Aux2: context.model.Aux2,
        Aux3: context.model.Aux3,
        Aux4: context.model.Aux4,
        ArticleID: context.articuloSelected.Id,
        Amount: context.model.Importe,
        IsAndroid: false,
        DeviceID: ""
      };

      axiosHelpers.axiosPost("Recarga/InsertAndWaitResult", req, this, function(
        data
      ) {
        if (data.Alerts.length == 0) {
          if (data.ResponseVM.TransactionStateID == context.estados.Aprobado) {
            // Si no tiene nro de transaccion (caso Hipodromo) no mostramos "Número de transacción:"
            let nroTranLine =
              data.ResponseVM.TransactionNumber.length != 0
                ? " Número de transacción: " +
                  data.ResponseVM.TransactionNumber +
                  "<br/>"
                : "";

            let msg =
              "La recarga se realizó satisfactoriamente" +
              "<br/>" +
              " Número de operación: " +
              data.ResponseVM.QueueID +
              "<br/>" +
              " Número de comprobante: " +
              data.ResponseVM.FormatedReceiptID +
              "<br/>" +
              nroTranLine;

            context.resultado = {
              Texto: msg,
              Tipo: "success",
              Icono: "fa fa-fw fa-thumbs-up"
            };

            if (
              context.articuloSelected.id ==
              context.$store.getters.EdenorArticleID
            ) {
              context.isEdenor = true;

              let msgTicket =
                "Ticket de la Recarga:" + "<br/>" + data.ResponseVM.Ticket;

              context.ticket = {
                Texto: msgTicket,
                Tipo: "success",
                Icono: "fa fa-fw fa-thumbs-up"
              };
            }
            context.$refs.wizard.nextTab();
          } else if (
            data.ResponseVM.TransactionStateID == context.estados.Rechazado ||
            data.ResponseVM.TransactionStateID == context.estados.Consulta
          ) {
            context.resultado = {
              Texto: data.ResponseVM.ErrorMsg,
              Tipo: "danger",
              Icono: "fa fa-fw fa-thumbs-down"
            };
            context.$refs.wizard.nextTab();
          } else {
            context.resultado = {
              Texto:
                "La operación esta demorando mas de lo normal, te avisaremos cuando este el resultado final de la operación",
              Tipo: "warning",
              Icono: "fa fa-fw fa-clock"
            };
            context.$refs.wizard.nextTab();
          }
        } else {
          context.resultado = {
            Texto: data.Alerts[0].Message,
            Tipo: "danger",
            Icono: "fa fa-fw fa-thumbs-down"
          };
          context.$refs.wizard.nextTab();
        }
      });
    },
    validate() {
      let context = this;

      if (!context.model.Validate) {
        if (context.model.Errors.length > 0) {
          context.model.Errors.forEach(element => {
            notificationHelpers.showError("Error", element, this);
          });
        } else {
          notificationHelpers.showError(
            "Error",
            "Debe completar todos los campos",
            this
          );
        }
        return;
      }

      this.realizarRecarga();
    },
    nuevaRecarga() {
      this.model = {
        Aux1: "",
        Aux2: "",
        Aux3: "",
        Aux4: "",
        Importe: 0,
        Errors: []
      };
      this.$router.go();
    },
    validateArticulo() {
      let context = this;
      return context.articuloSelected != { id: 0, image: "", name: "" };
    },
    itemClicked(itemSelected) {
      let context = this;

      context.articuloSelected = itemSelected;
      context.btnRecargarDisabled = false;
      context.model = {
        Aux1: "",
        Aux2: "",
        Aux3: "",
        Aux4: "",
        Importe: 0,
        Errors: [],
        Validated: false
      };
      context.$refs.wizard.nextTab();
    },
    onSaldoOK(val) {
      this.btnRecargarDisabled = !val;
    }
  },
  beforeMount: function() {

    let context = this;
    this.cargarArticulos(this);
    
    this.JuninArticleID = store.getters.JuninParkingArticleID;
    this.CordobaArticleID = store.getters.CordobaParkingArticleID;
    this.OlavarriaArticleID = store.getters.OlavarriaParkingArticleID;
  },
  mounted() {

    

  }
};
</script>
    
